import * as angular from "angular";
import {IController} from "angular";
import {AgentModel} from "../../angular/models/agent.model";

export class AgentRegistrationStatusCtrl implements IController {

  agent: AgentModel;
}

angular
  .module('bringoz.admin.agents')
  .component('agentRegistrationStatus', {
    bindings: {
      agent: '<'
    },
    template: require('./agent-registration-status.html').default,
    controller: AgentRegistrationStatusCtrl
  });
